import { Checkbox } from '@microservices/wiskey-react-components'
import { GridColDef } from '@mui/x-data-grid'

import { SYSTEM_SELECT_COLUMN } from '@constants'

export const generateConfigSelectColumn = ({ onSelectRow, selectedConfigId }): GridColDef => ({
  field: SYSTEM_SELECT_COLUMN,
  headerName: '',
  width: 55,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  align: 'center',
  headerAlign: 'center',
  renderCell: params => {
    const configId = String(params.row.id)

    return (
      <Checkbox
        checked={selectedConfigId === configId}
        onClick={e => e.stopPropagation()}
        onChange={(e, checked) => {
          e.stopPropagation()
          onSelectRow(checked ? configId : null)
        }}
      />
    )
  },
})
